module.exports = __webpack_public_path__ + "img/taobao.b92bdfde.png";